import React, { Component } from "react";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import SwalServices from "../../services/swalServices/SwalServices.js";

class RMCategoryMaster extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isLoading: false,
      isEditing: false,
      tableStatus: "",
      rmCategoryListing: [],
      rmCategoryDetails: {
        rmCategory: "",
      },
    };
  }

  componentDidMount() {
    this.getAllRMCategory();
  }

  getAllRMCategory = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllRMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { rmCategoryListing: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  addEditRMCategory = () => {
    if (this.state.rmCategoryDetails.rmCategory !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.rmCategoryDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditRMCategory(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllRMCategory();
            this.resetForm();
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.rmCategoryDetails;
    details.rmCategory = "";
    this.setState({ rmCategoryDetails: details, _id: "", tableStatus: "", isEditing: false });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.rmCategoryDetails;
    details[name] = value.toUpperCase();
    this.setState({ rmCategoryDetails: details });
  };

  getCategoryById = (group) => {
    let details = this.state.rmCategoryDetails;
    details.rmCategory = group.rmCategory;
    this.setState({ rmCategoryDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteRMCategoryById = (id) => {
    this.itemMasterServices.deleteRMCategoryById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllRMCategory();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp w-[50%] !mb-3.5">
              <label>R.M. Category</label>
              <input
                className="inputFocus"
                type="text"
                id="rmCategory"
                name="rmCategory"
                autoComplete="off"
                value={this.state.rmCategoryDetails.rmCategory}
                onChange={(event) => this.handleChange(event, "rmCategory")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditRMCategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditRMCategory()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()}
                disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList ">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Category Name</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.rmCategoryListing &&
                    this.state.rmCategoryListing.length > 0 ?
                    this.state.rmCategoryListing.map((group, key) => (
                      <tr key={key}>
                        <td>{group.rmCategory}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getCategoryById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteRMCategoryById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.rmCategoryListing &&
                      this.state.rmCategoryListing.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.rmCategoryListing &&
                      this.state.rmCategoryListing.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RMCategoryMaster;
